import { Utils } from "../../core/utils";
import * as Constants from "../../core/constants";

export class ScfInvoiceDashboard {

    constructor() {
        Utils.pageSanityHandler();
    }

    handler() {
        this.dtHandler();
    }

    mainTableTransformer(data) {
        data.formatted_created_at = Utils.formatTime(data.created_at);
        data.formatted_updated_at = Utils.formatTimeRelative(data.updated_at);
        data.total_invoice_value = data.total_invoice_value ? data.total_invoice_value.toLocaleString('en-IN') : "NA";
        data.formatted_due_date = data.due_date ? Utils.formatDate(data.due_date) : 'NA';
        data.formatted_due_date_relative = data.due_date ? Utils.formatTimeRelative(data.due_date) : 'NA';
        let badge_invoice_state = { "finance_requested": "bg-warning", "verified": "bg-info", "buyer_approved": "bg-success", "buyer_rejected": "bg-danger", "flexi_approved": "bg-success", "flexi_rejected": "bg-danger", "sent_to_checker": "bg-info", "sent_for_ddr": "bg-info", "rejected_from_ddr": "bg-danger", "lender_sanctioned": "bg-success", "lender_rejected": "bg-danger", "lender_disbursed": "bg-success", "duplicate": "bg-warning", "closed": "bg-secondary" };
        data.badge_invoice_status = badge_invoice_state[data.status];
        data.status = Utils.capitalizeFirstLetter(data.status.split('_').join(' '));
        data.formatted_purpose = Utils.capitalizeFirstLetter(data.purpose.split('_').join(' '));
        data.badge_purpose = 'badge-primary';
        if (data.purpose === 'finance') {
            data.badge_purpose = 'badge-green';
        }

        return data;
    }

    dtHandler() {
        let table_container_id = '#dt-table-application';
        let dt_instance = Utils.renderDataTable(table_container_id + '> table');
        Utils.initializeDataTable(
            table_container_id,
            dt_instance,
            '/scf/api/invoices',
            Constants.REQUEST.get,
            {},
            'dt-main-tmpl',
            this.mainTableTransformer,
            'data',
            {});
    }

}

export class ScfDueInvoiceDashboard {
    constructor() {
        Utils.pageSanityHandler();
    }

    handler() {
        this.dtHandler();
    }

    mainTableTransformer(data) {
        data.other_charges = data.other_charges.toFixed(2);

        const today = new Date();
        const dueDateParts = data.due_date.split('-'); // Assume dd-mm-yyyy format
        const dueDate = new Date(dueDateParts[2], dueDateParts[1] - 1, dueDateParts[0]);
        const isPastDue = dueDate < today;
        const isTodayOrFutureDue = dueDate >= today;

        data.due_date_badge = "bg-warning"
        if (isPastDue) {
            data.due_date_badge = "bg-danger";
        }

        // Calculate the difference in days
        const diffTime = dueDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days

        // Add overdue or pending days information
        if (diffDays < 0) {
            data.overdue_days = Math.abs(diffDays); // Overdue days (positive number)
            data.due_status_message = `${Math.abs(diffDays)} days overdue`;
        } else {
            data.pending_days = diffDays; // Days remaining (positive number)
            data.due_status_message = `Due in ${diffDays} days`;
        }
        return data;
    }

    dtHandler() {
        let table_container_id = '#dt-table-application';
        let dt_instance = Utils.renderDataTable(table_container_id + '> table');
        Utils.initializeDataTable(
            table_container_id,
            dt_instance,
            '/scf/api/invoice/due-invoices',
            Constants.REQUEST.get,
            {},
            'dt-due-invoice-main-tmpl',
            this.mainTableTransformer,
            'data',
            {});
    }
}
